export enum EReferents {
  AGENTS = "referer",
  AGENCY = "areferer",
}

// const
export const CReferents = EReferents;
// type
export type TReferents = `${EReferents}`;
